// NO EDITAR A MANO
// const id = "footer.link_apps.url-huawei";
const valor = `https://appgallery7.huawei.com/#/app/C101411075`;

export default valor;
